/* ==========================================================
   ADICIONA " MXN" AO FINAL DOS PREÇOS
   - Não muda o valor (contém o preço real do Shopify)
   - Só ajusta a aparência: $529.00 -> $529.00 MXN
   ========================================================== */
(function () {
  'use strict';

  var CURRENCY_SUFFIX = ' MXN';

  // Seletores que contêm preços no tema bs- e também no Horizon padrão
  var PRICE_SELECTORS = [
    '.bs-price-current',
    '.bs-price-original',
    '.bs-price-new',
    '.bs-price-old',
    '.bs-sticky-price',
    '.bs-sticky-old',
    '.price-item',
    '.price-item--regular',
    '.price-item--sale',
    '.price__current',
    '.price__compare',
    '.price__sale .price-item',
    '.product-card__price .price',
    '.product-price__current',
    '.product__price--current',
    '.product__price--compare'
  ];

  function needsSuffix(text) {
    if (!text) return false;
    var t = text.trim();
    if (!t) return false;
    // Já tem MXN/BRL/USD/etc no final? não adicionar
    if (/(MXN|BRL|USD|EUR|GBP)\s*$/i.test(t)) return false;
    // Tem um preço (qualquer símbolo de moeda + número)?
    if (/(R\$|US?\$|\$|€|£)\s*[\d.,]+/.test(t)) return true;
    // Também casos sem símbolo mas com números + vírgula (ex: "529,00")
    if (/^\s*[\d.,]+\s*$/.test(t) && /[\d]/.test(t)) return true;
    return false;
  }

  function addSuffixToText(el) {
    if (!el || !el.firstChild) {
      // sem filhos, mas pode ter textContent
      if (el && el.textContent && needsSuffix(el.textContent)) {
        el.textContent = el.textContent.trim() + CURRENCY_SUFFIX;
        el.dataset.cmpDone = '1';
      }
      return;
    }
    // Itera nos nós de texto procurando o que parece preço
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    var anyChange = false;
    while ((node = walker.nextNode())) {
      var t = node.textContent;
      if (needsSuffix(t)) {
        node.textContent = t.replace(/\s*$/, '') + CURRENCY_SUFFIX;
        anyChange = true;
      }
    }
    if (anyChange) el.dataset.cmpDone = '1';
  }

  function applyOnce(el) {
    if (!el) return;
    // Evita reprocessar
    if (el.dataset.cmpDone === '1') {
      // mas re-checa se o texto perdeu o sufixo (mudou via JS de variant)
      if (!/MXN\s*$/i.test(el.textContent || '')) {
        delete el.dataset.cmpDone;
      } else {
        return;
      }
    }
    addSuffixToText(el);
  }

  function applyAll() {
    PRICE_SELECTORS.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(applyOnce);
    });
  }

  function run() { try { applyAll(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [200, 500, 1200, 2500, 4500].forEach(function (ms) { setTimeout(run, ms); });

  // Observa mudanças no DOM (variant change, lazy load)
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { run(); pending = false; }, 60);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
